import script from "./Exchange.vue?vue&type=script&setup=true&lang=js"
export * from "./Exchange.vue?vue&type=script&setup=true&lang=js"

import "./Exchange.vue?vue&type=style&index=0&id=7462f7d1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7462f7d1"]])

export default __exports__